// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KcIP","newExpiryDate":"styles_newExpiryDate__2_LFL","footer":"styles_footer__oH8uJ"};